import './ReceptionLogisticForm.scss';

import { Form } from 'antd';
import Input from 'antd/es/input/Input';
import { useTranslation } from 'react-i18next';

const ReceptionLogisticForm = () => {
  const { t } = useTranslation();

  return (
    <div className="ReceptionLogisticForm">
      <div className="ReceptionFormRow">
        <Form.Item label={t('Observación')} name={'comment'}>
          <Input />
        </Form.Item>
      </div>
    </div>
  );
};

export default ReceptionLogisticForm;
